export var PreWarmSourceTypes;
(function (PreWarmSourceTypes) {
    PreWarmSourceTypes["CCM"] = "ccm";
    PreWarmSourceTypes["DirectMCM"] = "directmcm";
    PreWarmSourceTypes["Home"] = "home";
})(PreWarmSourceTypes || (PreWarmSourceTypes = {}));
//# sourceMappingURL=preWarmUtils.js.map